// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.staging.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    version: '1.000.0',
    production: false,
    errMsg: 'Failed to complete. Please try again.',
    partner: false,
    config: {
        "stage": "staging",
        "appName": "INTERNAL",
        "auth": {
            "caretakerUrl": "https://caretaker.staging.service.75f.io/api/v1",
            "gatekeeperUrl": "https://gatekeeper.staging.service.75f.io/api/v1"
        },
        "multiRegion": false,
        "defaultRegion": "1",
        "regionsList": ["1"],
        "1" : {
            "regionName": "North America",
            "haystackUrl": "https://silo.staging.service.75f.io/",
            "tagsUrl": "https://silo.staging.service.75f.io/v2/sitePointTags",
            "cpmUrl": "https://chiller-plant.staging.service.75f.io/",
            "alertsUrl": "https://alerts.staging.service.75f.io/",
            "pasUrl": `https://portfolio-analytics.staging.service.75f.io`,
        }
    }
};